// extracted by mini-css-extract-plugin
module.exports = {"container":"LazyImage_container__HAfdz","placeholder":"LazyImage_placeholder__xvEon","loadingAnimation":"LazyImage_loadingAnimation__B5pol","image":"LazyImage_image__9DNTT"};